"use client";

import { BackgroundImageCard } from "@repo/ui/components/common/cms";
import type { LinkedItem } from "@repo/ui/types/cms/common";

import { TravelInfoList } from "./TravelInfoList";

interface DesktopLayoutProps {
  item: LinkedItem;
}

const DesktopLayout = ({ item }: DesktopLayoutProps) => {
  const [backgroundImageCards] = item?.linked_items
    ? item.linked_items.filter((li) => li.background_image_cards)
    : [];

  const iconTextCtaCards = item?.linked_items
    ? item.linked_items
        .filter((li) => li.icon_text_cta_cards)
        .map((li) => ({
          title: li.title,
          subtitle: li.subtitle,
          icon_text_cta_cards: li.icon_text_cta_cards,
        }))
    : [];

  return (
    <div className="hidden grid-cols-12 gap-6 lg:grid" data-testid="desktop-layout-section">
      <div className="col-span-4 flex flex-col gap-6" data-testid="background-image-cards-section">
        {backgroundImageCards?.background_image_cards &&
          backgroundImageCards.background_image_cards.length > 0 &&
          backgroundImageCards.background_image_cards.map((card) => (
            <BackgroundImageCard
              key={card.title}
              card={card}
              testId={`background-image-card-${card.title?.toLowerCase().replace(/\s+/g, "-")}`}
            />
          ))}
      </div>
      <div className="col-span-8 grid grid-cols-3 gap-4" data-testid="icon-text-cta-cards-section">
        {iconTextCtaCards.length > 0 &&
          iconTextCtaCards.map((item) => (
            <TravelInfoList
              key={item.title}
              title={item.title}
              items={item.icon_text_cta_cards}
              testId={`travel-info-list-${item.title?.toLowerCase().replace(/\s+/g, "-")}`}
            />
          ))}
      </div>
    </div>
  );
};

export default DesktopLayout;
